import { Component, OnInit, Input } from '@angular/core';
import { SellerModel } from '../seller-main/seller-main.component';

@Component({
  selector: 'app-seller-right',
  templateUrl: './seller-right.component.html',
  styleUrls: ['./seller-right.component.scss']
})
export class SellerRightComponent implements OnInit {

  @Input() seller: SellerModel;

  constructor() { }

  ngOnInit() {
  }

}
